// src/pages/ResetPassword.jsx
import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

// const BACKEND_URL = 'http://localhost:3001';
const BACKEND_URL = '/api';

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (password !== confirm) {
      setError('Le password non coincidono.');
      return;
    }

    if (!token) {
      setError('Token non valido o mancante.');
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(`${BACKEND_URL}/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, newPassword: password }),
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.error || 'Errore durante il reset della password.');
      } else {
        setMessage('Password aggiornata con successo. Verrai reindirizzato...');
        setTimeout(() => navigate('/login'), 2000);
      }
    } catch (err) {
      console.error(err);
      setError('Errore di connessione al server.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="text-white font-bold">
      <form
        className="max-w-md mx-auto mt-20 p-6 bg-white shadow-md rounded"
        onSubmit={handleSubmit}
      >
        <h1 className="text-2xl font-bold mb-4 text-gray-800">
          Imposta nuova password
        </h1>

        <input
          type="password"
          placeholder="Nuova password"
          className="w-full mb-3 p-2 border rounded text-black"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        <input
          type="password"
          placeholder="Conferma password"
          className="w-full mb-4 p-2 border rounded text-black"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          required
        />

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 transition disabled:opacity-60"
        >
          {loading ? 'Salvataggio...' : 'Salva nuova password'}
        </button>

        {message && (
          <p className="text-green-600 mt-2 text-sm font-normal">{message}</p>
        )}
        {error && (
          <p className="text-red-500 mt-2 text-sm font-normal">{error}</p>
        )}
      </form>
    </div>
  );
}
